import ApiClient from './apiClient'
import { QueriesApi } from './apiTypes'


const volumeBackupService = {
  getBackupList:(queries:QueriesApi) => ApiClient.get('openstack/volumebackups', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  createBackup:(data:any) => ApiClient.post('openstack/volumebackups', data),
  deleteBackup:(backupId:string) => ApiClient.delete(`openstack/volumebackups/${backupId}`),
  getBackup:(backupId:string) => ApiClient.get(`openstack/volumebackups/${backupId}`),
}

export default volumeBackupService
